<template>
  <div class="shipping-form__shipping">
    <div class="container-fluid">
      <div class="row">
        <div class="col customer-type">
          <p class="label">Shipment Method</p>
          <div class="d-flex mt-3 mb-4">
            <label class="radio-label" for="terminal-to-terminal">
              <input
                type="radio"
                id="terminal-to-terminal"
                value="terminal-to-terminal"
                v-model="shippingInformation.shippingMethod"
              />
              Terminal-to-Terminal
              <span></span>
            </label>

            <label class="radio-label ml-4" for="door-door">
              <input
                type="radio"
                id="door-door"
                value="door-door"
                v-model="shippingInformation.shippingMethod"
              />
              Door-to-Door
              <span></span>
            </label>

            <label class="radio-label ml-4" for="terminal-to-door">
              <input
                type="radio"
                id="terminal-to-door"
                value="terminal-to-door"
                v-model="shippingInformation.shippingMethod"
              />
              Terminal-to-Door
              <span></span>
            </label>
          </div>
        </div>
      </div>
      <div v-if="shippingInformation.shippingMethod == 'terminal-to-terminal'">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label for="name" class="label">Drop-off Location</label> <br />
              <el-select
                v-model="shippingInformation.dropOff"
                placeholder="Select"
              >
                <el-option
                  v-for="option in takeOffArray"
                  :key="option.id + '_dropoff'"
                  :label="option.locationName"
                  :value="option.id"
                >
                </el-option>
              </el-select>
              <p class="text-red-700 text-sm">
                {{
                  takeOffArray.length == 0
                    ? "There are no Terminals for this Location"
                    : ""
                }}
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label for="name" class="label">Pickup Location</label> <br />
              <el-select
                v-model="shippingInformation.pickUp"
                placeholder="Select"
              >
                <el-option
                  v-for="option in pickUpArray"
                  :key="option.id + '_pickup'"
                  :label="option.locationName"
                  :value="option.id"
                >
                </el-option>
              </el-select>
              <p class="text-red-700 text-sm">
                {{
                  pickUpArray.length == 0
                    ? "There are no Terminals for this Location"
                    : ""
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="label">Select Shipping Service</label>
          </div>
        </div>
        <div class="row">
          <div class="shipping-services">
            <div
              class="align-items-stretch"
              v-for="shippingService in shippingServiceTerminal"
              :key="shippingService.id"
            >
              <div
                class="shipping-service cursor-pointer h-100"
                :class="{
                  selected:
                    shippingInformation.shippingServiceId == shippingService.id,
                }"
                @click="
                  (shippingInformation.shippingServiceId = shippingService.id),
                    savePaymentInformation(shippingService);
                  getCostEngine();
                "
              >
                <p class="service-name">{{ shippingService.orgName }}</p>

                <p class="service-schedule">
                  Next Day {{ shippingService.shippingMethod }} Service
                </p>
                <p class="mb-2">
                  {{ shippingService.takeOffLocation }} -
                  {{ shippingService.arrivalLocation }}
                </p>
                <p class="arrival-date">
                  Arrives {{ shippingService.arrivalTime }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex flex-nowrap justify-start gap-4"
          v-if="Object.keys(costs).length > 0"
        >
          <CostTypes
            costType="Express"
            :total="
              costs.expressCost.totalCost != null
                ? costs.expressCost.totalCost.toString()
                : 0.0
            "
            :currentSelected="costSelected"
            @selected="setSelected"
          />
          <CostTypes
            costType="Standard"
            :total="
              costs.standardCost.totalCost != null
                ? costs.standardCost.totalCost.toString()
                : 0.0
            "
            :currentSelected="costSelected"
            @selected="setSelected"
          />
          <CostTypes
            costType="Economy"
            :total="
              costs.economyCost.totalCost != null
                ? costs.economyCost.totalCost.toString()
                : 0.0
            "
            :currentSelected="costSelected"
            @selected="setSelected"
          />
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div
              class="input-wrapper"
              v-if="shippingInformation.tripMode == 'multi-trip'"
            >
              <label for="name" class="label">Stop(s) Along Your Route</label>
              <input
                type="text"
                class="input"
                placeholder="Enter multiple stops"
                v-model="singleStop"
              />
              <div
                v-for="(stopInput, index) in stopsInputs"
                :key="index"
                class="flex items-center"
              >
                <span class="w-11/12 mr-2"
                  ><input
                    type="text"
                    class="input"
                    placeholder="Enter stop"
                    v-model="stopInput.name"
                /></span>
                <span
                  v-if="index + 1 == stopsInputs.length"
                  class="cursor-pointer"
                  @click="addStop"
                  ><svg
                    width="25"
                    height="25"
                    viewBox="0 0 30 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.0007 0.717773C6.71671 0.717773 0.000976562 7.42982 0.000976562 15.7092C0.000976562 23.9882 6.71661 30.7009 15.0005 30.7009C23.2844 30.7009 30.0008 23.9882 30.0008 15.7092C30.0008 7.42982 23.2845 0.717773 15.0007 0.717773ZM21.3288 17.3583H16.5018V22.4023C16.5015 23.2481 15.8155 23.9337 14.969 23.9337C14.1222 23.9337 13.4362 23.2481 13.4362 22.4018V17.3583H8.73779C7.8912 17.358 7.20551 16.6724 7.20501 15.8264C7.20501 14.9806 7.8913 14.2947 8.73779 14.2945L13.4361 14.2948V9.81825C13.4361 8.97213 14.1224 8.28633 14.9687 8.28633C15.8155 8.28633 16.5018 8.97223 16.5015 9.81825L16.5018 14.2944L21.3283 14.2949C22.1749 14.2944 22.8613 14.9805 22.861 15.8268C22.8613 16.6729 22.1749 17.3583 21.3288 17.3583Z"
                      fill="#10233E"
                    />
                  </svg>
                </span>
              </div>
              <div class="flex" v-if="stopsInputs.length == 0">
                <span
                  @click="addStop"
                  class="text-sm ml-auto underline font-semibold cursor-pointer"
                  >+ Add Stops</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label for="name" class="label">Preferred Pick-up Day</label>
              <br />
              <el-date-picker
                v-model="selectedPickupDay"
                type="date"
                placeholder="Pick a day"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Preferred Pick-up Time</label>
              <div class="flex">
                <el-time-picker
                  value-format="HH:mm:ss"
                  placeholder="00 : 00 am"
                  v-model="preferredPickupTime1"
                >
                </el-time-picker>
                <span class="mx-3">-</span>

                <el-time-picker
                  value-format="HH:mm:ss"
                  placeholder="00 : 00 am"
                  v-model="preferredPickupTime2"
                >
                </el-time-picker>
              </div>
              <span
                class="block w-full text-red-500"
                v-if="invalidCollectionTime"
                >Collection time range in correct</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label for="name" class="label">Preferred Delivery day</label>
              <el-date-picker
                v-model="selectedDropoffDay"
                type="date"
                placeholder="Pick a day"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="input-wrapper">
              <label class="label">Preferred Delivery Time</label>

              <div class="flex">
                <el-time-picker
                  value-format="HH:mm:ss"
                  placeholder="00 : 00 am"
                  v-model="preferredDropoffTime1"
                >
                </el-time-picker>
                <span class="mx-3">-</span>

                <el-time-picker
                  value-format="HH:mm:ss"
                  placeholder="00 : 00 am"
                  v-model="preferredDropoffTime2"
                >
                </el-time-picker>
              </div>
              <span class="block w-full text-red-500" v-if="invalidDeliveryTime"
                >Delivery time range in correct</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="col-sm-12 col-md-12 col-lg-6"
            v-if="$store.getters.packageType == 'truck'"
          >
            <div class="input-wrapper">
              <label
                >Mode of Trip
                <tool-tip
                  text="In Single Trip, goods are picked from the location and delivered to the desired receiver with no stop(s). Multi Trip enables your goods to be picked from a location and delivered at marked stops present throughout the route."
                />
              </label>
              <div class="d-flex mt-3 mb-4">
                <label class="radio-label" for="single-trip">
                  <input
                    type="radio"
                    id="single-trip"
                    value="single-trip"
                    v-model="shippingInformation.tripMode"
                  />
                  Single Trip
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="multi-trip">
                  <input
                    type="radio"
                    id="multi-trip"
                    value="multi-trip"
                    v-model="shippingInformation.tripMode"
                  />
                  Multi-Trip
                  <span></span>
                </label>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-6">
            <div
              class="input-wrapper"
              v-if="shippingInformation.tripMode == 'multi-trip'"
            >
              <label for="name" class="label">Stop(s) Along Your Route</label>
              <input
                type="text"
                class="input"
                placeholder="Enter multiple stops"
                v-model="singleStop"
              />
              <div
                v-for="(stopInput, index) in stopsInputs"
                :key="index"
                class="flex items-center"
              >
                <span class="w-11/12 mr-2"
                  ><input
                    type="text"
                    class="input"
                    placeholder="Enter stop"
                    v-model="stopInput.name"
                /></span>
                <span
                  v-if="index + 1 == stopsInputs.length"
                  class="cursor-pointer"
                  @click="addStop"
                  ><svg
                    width="25"
                    height="25"
                    viewBox="0 0 30 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.0007 0.717773C6.71671 0.717773 0.000976562 7.42982 0.000976562 15.7092C0.000976562 23.9882 6.71661 30.7009 15.0005 30.7009C23.2844 30.7009 30.0008 23.9882 30.0008 15.7092C30.0008 7.42982 23.2845 0.717773 15.0007 0.717773ZM21.3288 17.3583H16.5018V22.4023C16.5015 23.2481 15.8155 23.9337 14.969 23.9337C14.1222 23.9337 13.4362 23.2481 13.4362 22.4018V17.3583H8.73779C7.8912 17.358 7.20551 16.6724 7.20501 15.8264C7.20501 14.9806 7.8913 14.2947 8.73779 14.2945L13.4361 14.2948V9.81825C13.4361 8.97213 14.1224 8.28633 14.9687 8.28633C15.8155 8.28633 16.5018 8.97223 16.5015 9.81825L16.5018 14.2944L21.3283 14.2949C22.1749 14.2944 22.8613 14.9805 22.861 15.8268C22.8613 16.6729 22.1749 17.3583 21.3288 17.3583Z"
                      fill="#10233E"
                    />
                  </svg>
                </span>
              </div>
              <div class="flex" v-if="stopsInputs.length == 0">
                <span
                  @click="addStop"
                  class="text-sm ml-auto underline font-semibold cursor-pointer"
                  >+ Add Stops</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="row ml-n5">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="input-wrapper">
              <label for="name" class="label">
                <base-checkbox
                  label="Add Return Address / Forwarding Address"
                  id="delivery-code"
                  v-model="addReturn"
                />

                <tool-tip
                  text="If package cannot be delivered, where should it be returned to?"
                />
              </label>
              <vue-google-autocomplete
                id="map2"
                ref="shipperAddress"
                classname="input"
                placeholder="Enter address"
                v-if="addReturn"
                v-on:placechanged="getAddress"
              >
              </vue-google-autocomplete>
            </div>
          </div>
        </div>

        <div class="row">
          <label class="label">Select Shipping Service</label>
        </div>
        <div class="shipping-services">
          <div
            class="align-items-stretch"
            @click="getShippingServices()"
            v-for="(shippingService, index) in shippingServices"
            :key="index"
          >
            <div
              class="shipping-service cursor-pointer h-100"
              :class="{
                selected:
                  shippingInformation.shippingServiceId == shippingService.id,
              }"
              @click="
                (shippingInformation.shippingServiceId = shippingService.id),
                  savePaymentInformation(shippingService);
                getCostEngine();
              "
            >
              <p class="service-name">{{ shippingService.orgName }}</p>

              <p class="service-schedule">
                Next Day {{ shippingService.shippingMethod }} Service
              </p>
              <p class="mb-2">
                {{
                  shippingService.arrivalLocation
                    ? shippingService.takeOffLocation
                    : "N/A"
                }}
                -
                {{
                  shippingService.takeOffLocation
                    ? shippingService.arrivalLocation
                    : "N/A"
                }}
              </p>
              <p class="arrival-date">
                Arrives {{ shippingService.arrivalTime }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="flex flex-nowrap justify-start gap-4"
          v-if="Object.keys(costs).length > 0"
        >
          <CostTypes
            costType="Express"
            :total="
              costs.expressCost.totalCost != null
                ? costs.expressCost.totalCost.toString()
                : 0.0
            "
            :currentSelected="costSelected"
            @selected="setSelected"
          />
          <CostTypes
            costType="Standard"
            :total="
              costs.standardCost.totalCost != null
                ? costs.standardCost.totalCost.toString()
                : 0.0
            "
            :currentSelected="costSelected"
            @selected="setSelected"
          />
          <CostTypes
            costType="Economy"
            :total="
              costs.economyCost.totalCost != null
                ? costs.economyCost.totalCost.toString()
                : 0.0
            "
            :currentSelected="costSelected"
            @selected="setSelected"
          />
        </div>
      </div>

      <div class="button-wrapper">
        <p class="cursor-pointer underline" @click="$emit('back-one-form')">
          Back
        </p>
        <span class="mr-6">
          <primary-button
            button-text="Continue"
            :loading="isLoading"
            :disabled="disableSubmit"
            @click="createShippingId"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import CostTypes from "../CostTypes";

export default {
  name: "shipping-details-form",
  components: {
    VueGoogleAutocomplete,
    CostTypes,
  },
  data() {
    return {
      shippingServiceTerminal: [],
      addReturn: false,
      shippingInformation: {
        shipperLocationId: null,
        consigneeLocationId: null,
        shippingMethod: null,
        tripMode: "single-trip",
        shippingServiceId: null,
        sourcePickupTime: null,
        destinationPickupTime: null,
        portOrigin: null,
        portDestination: null,
        payOnDelivery: false,
        deliveryConfirmation: false,
        paymentStatus: "not-paid",
        stops: [],
        returnOrForwardingAddress: null,
        currentStep: 4,
        dropOff: "",
        pickUp: "",
      },
      payload: {
        shipperLocationId: "",
        consigneeLocationId: "",
        shippingMethod: "",
        shippingServiceId: "",
        tripMode: "single-trip",
        sourcePickupTime: "",
        paymentStatus: "not paid",
        destinationPickupTime: "",
        portOrigin: "",
        portDestination: "",
        stops: "",
        payOndelivery: "",
        specifiedAmount: "",
        returnOrForwardingAddress: "",
        deliveryConfirmation: "",
      },
      transactionId: "",
      singleStop: "",
      selectedPickupDay: "",
      selectedDropoffDay: "",
      stopsInputs: [],
      preferredPickupTime1: "",
      preferredPickupTime2: "",
      preferredDropoffTime1: "",
      preferredDropoffTime2: "",
      selectedShippingService: "",
      invalidCollectionTime: false,
      takeOffArray: [],
      validProps: true,
      pickUpArray: [],
      invalidDeliveryTime: false,
      paymentOnDeliveryOptions: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      isLoading: false,
      shippingServices: [],
      paymentInformation: {
        packageeId: "",
        serviceCost: "",
        serviceType: "",
      },
      costs: [],
      costSelected: "",
    };
  },
  watch: {
    "shippingInformation.shippingServiceId"() {
      this.getShippingServiceDetails();
    },
    pickUp() {
      if (!this.checkCollectionTime()) {
        this.invalidCollectionTime = true;
        this.validProps = false;
        return;
      }
      this.invalidCollectionTime = false;
      this.validProps = true;
    },
    delivery() {
      if (!this.checkDeliveryTime()) {
        this.invalidDeliveryTime = true;
        this.validProps = false;
        return;
      }
      this.invalidDeliveryTime = false;
      this.validProps = true;
    },
    "shippingInformation.dropOff"(dropOff) {
      if (this.shippingInformation.pickUp) {
        this.getShippingServicesByTerminal(
          dropOff,
          this.shippingInformation.pickUp
        );
      }
    },
    "shippingInformation.pickUp"(pickUp) {
      if (this.shippingInformation.dropOff) {
        this.getShippingServicesByTerminal(
          this.shippingInformation.dropOff,
          pickUp
        );
      }
    },
  },
  activated() {
    this.shippingService = [];
    this.cost = [];
    this.getShippingService();
  },
  computed: {
    pickUp() {
      // A dummy data just to keep track of pick-up
      return [this.preferredPickupTime2, this.preferredPickupTime1];
    },
    delivery() {
      // A dummy data just to keep track of deleivery-up
      return [this.preferredDropoffTime1, this.preferredDropoffTime2];
    },
    isNewConsignee() {
      return this.$store.getters.isNewConsignee;
    },
    packageType() {
      return this.$store.getters.packageType;
    },
    disableSubmit() {
      return this.shippingInformation.payOnDelivery.length == 0 ||
        this.shippingInformation.shippingServiceId == null ||
        this.costSelected.length == 0 ||
        (this.shippingInformation.shippingMethod == "terminal-to-terminal" &&
          (this.shippingInformation.dropOff.length == 0 ||
            this.shippingInformation.pickUp.length == 0))
        ? true
        : false;
    },
  },
  mounted() {
    this.getShippingServices();
    this.getTerminals();
    this.getDoorToDoorShippingServices();
    console.log(JSON.stringify(this.shippingInformation, null, 2));
    if (this.shippingInformation.shippingMethod == null) {
      this.shippingInformation.shippingMethod = "door-door";
    }

    this.shippingInformation = this.$store.getters.shippingInformation;
    if (this.$store.getters.shippingInformation.shippingMethod == null) {
      this.$store.getters.shippingInformation.shippingMethod = "door-door";
    }
  },
  methods: {
    compareTime(start, end) {
      return (
        this.sumUpArray(end.split(":")) > this.sumUpArray(start.split(":"))
      );
    },
    sumUpArray(val) {
      let total = 0;
      total = total + Number(val[0]) * 3600;
      total = total + Number(val[1]) * 60;
      total = total + Number(val[2]);

      return total;
    },
    checkCollectionTime() {
      return this.compareTime(
        this.preferredPickupTime1,
        this.preferredPickupTime2
      );
    },
    checkDeliveryTime() {
      return this.compareTime(
        this.preferredDropoffTime1,
        this.preferredDropoffTime2
      );
    },
    async getDoorToDoorShippingServices() {
      await this.$_serviceTerminals();
    },
    async getTerminals() {
      let shipperAdd = this.$store.getters.shipperInformation.address;
      let consigneeAdd = this.$store.getters.consigneeInformation.address;
      const payload = {
        orgId: this.$store.state.authentication.organizationId,
        arrivalLocation: {
          lat: consigneeAdd.lat,
          lng: consigneeAdd.lng,
        },
        takeOffLocation: {
          lat: shipperAdd.lat,
          lng: shipperAdd.lng,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);
        console.log(JSON.stringify(response, null, 2));

        this.takeOffArray = response.data.data.takeOffLocation;
        this.pickUpArray = response.data.data.arrivalLocation;

        this.$store.dispatch("saveTakeOffTerminals", this.takeOffArray);
        this.$store.dispatch("savePickUpTerminals", this.pickUpArray);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getServiceTerminals() {
      try {
        await this.$_serviceTerminals();
      } catch (error) {
        this.handleError(error);
      }
    },
    async createShippingId() {
      if (this.isLoading && this.validProps) return;

      this.isLoading = true;

      this.shippingInformation.shipperLocationId =
        this.$store.getters.takeOffLocationId;
      this.shippingInformation.consigneeLocationId =
        this.$store.getters.deliveryLocationId;
      this.shippingInformation.sourcePickupTime =
        this.selectedPickupDay + " " + this.preferredPickupTime1;
      this.shippingInformation.destinationPickupTime =
        this.selectedDropoffDay + " " + this.preferredDropoffTime1;

      this.shippingInformation.id = this.$store.state.bookingModule.shippingId;

      if (this.shippingInformation.shippingMethod == "terminal-to-terminal") {
        delete this.shippingInformation.sourcePickupTime;
        delete this.shippingInformation.destinationPickupTime;
      } else if (this.shippingInformation.shippingMethod == "door-door") {
        delete this.shippingInformation.pickUp;
        delete this.shippingInformation.dropOff;
      }

      let payload = {
        payload: this.shippingInformation,
      };
      try {
        let response = await this.$_createShippingId(payload);
        response = await this.$_createShippingId(payload);
        this.$store.dispatch("saveShippingId", response.data.data.shipping.id);

        this.handleResponse(response);
      } catch (error) {
        this.handleError(error);
      }
      this.isLoading = false;
    },
    newshipping() {
      this.payload.shipperLocationId = this.$store.getters.takeOffLocationId;
      this.payload.consigneeLocationId = this.$store.getters.deliveryLocationId;
      this.payload.sourcePickupTime =
        this.selectedPickupDay + ", " + this.preferredPickupTime1;
      this.payload.destinationPickupTime =
        this.selectedDropoffDay + ", " + this.preferredDropoffTime1;
      this.isLoading = true;
    },
    async submitShippingInformation() {
      this.shippingInformation.shipperLocationId =
        this.$store.getters.takeOffLocationId;
      this.shippingInformation.consigneeLocationId =
        this.$store.getters.deliveryLocationId;
      this.shippingInformation.sourcePickupTime =
        this.selectedPickupDay + ", " + this.preferredPickupTime1;
      this.shippingInformation.destinationPickupTime =
        this.selectedDropoffDay + ", " + this.preferredDropoffTime1;
      this.isLoading = true;
      try {
        const response = await this.$_submitShippingInformation(
          { payload: this.shippingInformation },
          this.$store.getters.shippingId
        );

        this.isLoading = false;
        this.handleResponse(response);
      } catch (error) {
        this.handleError(error);
      }
      this.isLoading = false;
    },
    handleResponse(response) {
      this.$store.dispatch("saveBookingInformation", {
        property: "shippingInformation",
        value: response.data.data.shipping,
      });
      console.log(JSON.stringify(response, null, 2));

      this.$emit("save-response", response.data.data.shipping);
      this.$store.dispatch("saveLastCompletedFormNo", 4);
      this.$emit("change-form");
    },
    submitPaymentInformation() {
      this.isLoading = true;

      let allPackageIds = this.$store.getters.packageIds;
      allPackageIds.forEach((id) => {
        this.paymentInformation.packageeId = id;
        this.processPackagePayment();
      });
      this.submitShippingInformation();
    },
    async processPackagePayment() {
      try {
        const response = await this.$_submitPaymentInformation(
          this.paymentInformation
        );
        const paymentInformation = response.data.data.payment;
        this.$store.dispatch(
          "saveSinglePaymentInformation",
          paymentInformation
        );
        this.$store.dispatch("savePaymentId", paymentInformation.id);
      } catch (error) {
        this.handleError(error);
      }
    },
    savePaymentInformation(paymentInformation) {
      this.$store.dispatch("savePaymentInformation", paymentInformation);
      this.paymentInformation.serviceCost = paymentInformation.serviceCost;
      this.paymentInformation.serviceType = paymentInformation.shippingMethod;
    },
    async getShippingServices() {
      try {
        let consigneeLocationId = "";

        if (this.$store.getters.consigneeInformation.location) {
          consigneeLocationId =
            this.$store.getters.consigneeInformation.location.id;
        } else {
          consigneeLocationId = this.$store.getters.consigneeInformation.id;
        }
        let shipperLocationId = "";
        if (this.$store.getters.shipperInformation.location) {
          shipperLocationId =
            this.$store.getters.shipperInformation.location.id;
        } else {
          shipperLocationId = this.$store.getters.shipperInformation.id;
        }

        const response = await this.$_getShippingServicesByRoute(
          shipperLocationId,
          consigneeLocationId
        );
        this.shippingServices = response.data.data.shippingServices;
      } catch (error) {
        this.handleError(error);
      }
    },

    async getShippingServiceDetails() {
      try {
        const response = await this.$_getShippingServiceById(
          this.shippingInformation.shippingServiceId
        );
        // this.shippingServices = response.data.data

        this.$store.dispatch("saveShippingService", response.data.data);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getCostEngine() {
      const payload = {
        shippingId: this.$store.state.bookingModule.shippingId,
        shippingServiceId: this.shippingInformation.shippingServiceId,
        type: "single",
      };

      try {
        const response = await this.$_getCostEngine(payload);

        this.$store.dispatch("saveCostTypes", response.data.data);

        this.costs = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    setSelected(type) {
      this.costSelected = type;
      this.$store.dispatch("saveCostType", type);
    },
    addStop() {
      this.stopsInputs.push({ name: "" });
    },
    getAddress(addressData) {
      this.shippingInformation.returnOrForwardingAddress = addressData.route;
    },
  },
};
</script>

<style lang="scss" scoped>
.shipping-form__shipping {
  --lightblue: #fbfcfe;
  padding: 2rem 2.5rem;
}

.shipping-form__sender {
  padding: 2rem 2.5rem;
}

.days {
  display: flex;
}

.day {
  background: var(--lightblue);
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 5px;
  color: #a5adb7;
  padding: 0.5rem;
  margin-right: 0.5rem;
  font-size: 0.9rem;
  width: 3.25rem;
  text-align: center;
  cursor: pointer;

  &.selected {
    background: #f1cf8c;
    color: var(--primaryblue);
    font-weight: 500;
  }
}

.label {
  color: var(--primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.check-label {
  font-size: 0.9rem;
}

.input {
  background: var(--lightblue);
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  backdrop-filter: blur(6px);
  border-radius: 2px;
}

.input::placeholder {
  color: #bec4d5;
}

.input:disabled {
  background-color: #f8f8f8;
  cursor: not-allowed;
}

.customer-type {
  margin: 1rem 1.5rem;
}

.input-wrapper {
  width: 90%;
  margin: 0 auto 2rem;
}

.customer-type h3 {
  font-size: 1.2rem;
}

.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
  margin-right: 1.5rem;
}

.shipping-services {
  padding: 1.5rem 0rem;
  display: flex;
  gap: 1rem;
  width: 100%;
  overflow-x: scroll;
}

.shipping-service {
  background: var(--lightblue);
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  text-align: center;
  color: var(--primaryblue);
  padding: 1.5rem 0;
  margin-bottom: 1.5rem;
  transition: 0.5s ease-in-out;
  width: 220px;

  &.selected {
    background: var(--primaryblue);
    color: #ffffff;

    hr {
      color: #ffffff;
    }
  }
}

.shipping-service:hover {
  transform: scale(1.05);
}

.service-name {
  opacity: 0.8;
  font-size: 0.9rem;
}

.service-price {
  font-weight: 500;
  font-size: 1.2rem;
  padding: 0.5rem 0 0.75rem;
}

.service-schedule {
  font-size: 0.8rem;
  padding: 1rem 0 0.8rem;
}

.arrival-date {
  font-size: 1rem;
  font-weight: 500;
}

hr {
  width: 80%;
  margin: 0 auto;
}

.row {
  margin-bottom: 1rem;
}

.radio-label span::after {
  background: #bec4d5;
}

.el-date-editor.el-input {
  width: 100%;
}
</style>
